import moment from 'moment';
import _ from 'lodash';
import { multipleColor } from './index';

const processData = (dataList, category) => {
  const dataMaps = Object.keys(category).map((key) => ({
    data: dataList.map((item) => item.subItems.find((item) => item.label === category[key]).value),
    name: category[key],
    color: multipleColor[key],
  }));
  return dataMaps;
};

const sortArrayByLabelArray = (objArr, arr) => {
  if (!objArr.entities || !objArr.entities.length) {
    return objArr;
  }
  const newObjArr = [];
  for (const i in arr) {
    const index = _.findIndex(objArr.entities, { label: arr[i] });
    newObjArr.push(objArr.entities[index]);
  }
  return { entities: newObjArr };
};

const startCreateTime = `${moment().subtract(6, 'day').format('YYYY-MM-DD')} 00:00:00`;
const endCreateTime = `${moment().format('YYYY-MM-DD')} 23:59:59`;
export { processData, sortArrayByLabelArray, startCreateTime, endCreateTime };
